import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment UserOnboarding on UserOnboarding {
    uuid
    owner
    flow
    steps
    completedSteps
    userProgress {
      step
      metadata {
        createdAt
        createdBy
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
